'use client';
import { CatInputField } from '@blocks-react/components/InputField';
import { FC, PropsWithChildren } from 'react';
import { Controller, useController, useFormContext } from 'react-hook-form';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import { CatInputFieldProps } from '@cat-ecom/pcc-components/src/components/request-service/types';

export const TaxModalInput: FC<PropsWithChildren<CatInputFieldProps>> = ({
  children,
  ...inputFieldProps
}) => {
  const { control, getValues, setValue } = useFormContext();
  const { name, rules } = inputFieldProps;
  const { field, fieldState } = useController({ name, control, rules });

  const status = fieldState?.error ? 'error' : undefined;
  const note = fieldState?.error?.message;

  const onBlChange = (e: BlocksChangeEvent): void => {
    field.onChange(e);
    setValue(name, e.detail.value);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CatInputField
          {...field}
          {...inputFieldProps}
          fieldNote={note}
          hideWordCount
          hideStepper
          status={status}
          value={getValues(name) ?? ''}
          onBlChange={onBlChange}
        />
      )}
    />
  );
};
